// extracted by mini-css-extract-plugin
export default {"form":"Input_form__D54Uv","label":"Input_label__x0gnC","input":"Input_input__noMnr"};